import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper } from '@mui/material';

import ContentBox from './layout/ContentBox';
import LoopbackProvider from '../loopback/LoopbackProvider';
import { redirectToLogin } from '../redux/actions';
import withRouter, { RouteType } from '../hoc/withRouter';

type State = {
  result: string;
  error?: string;
}

class ActivateUser extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      result: 'pending',
    };
  }

  componentDidMount() {
    const { router } = this.props;
    this.doActivation(router.location.search);
  }

  async doActivation(search: string) {
    const { router } = this.props;
    const url = `${LoopbackProvider.loopbackHost}QuipUsers/confirm${search}`;
    try {
      const result = await fetch(url); // eslint-disable-line no-undef
      if (Math.floor(result.status / 100) !== 2) {
        switch (result.status) {
          case 512:
            this.setState({ result: 'error', error: 'registration.outdatedToken' });
            break;
          case 513:
            this.setState({ result: 'error', error: 'registration.doubleConfirmation' });
            // setTimeout(this.props.redirectToLogin, 2000);
            break;
          default:
            this.setState({ result: 'error', error: 'registration.genericActivationFailure' });
            break;
        }
      } else {
        this.setState({ result: 'success' });
        setTimeout(() => {
          redirectToLogin(router.navigate);
        }, 2000);
      }
    } catch (error) {
      this.setState({ result: 'error', error: (error as Error).message });
    }
  }

  render() {
    const { result, error } = this.state;
    const finished = result !== 'pending';
    if (!finished) {
      return false;
    }

    const viewStyle = {
      width: '50%',
      margin: '0 auto',
      marginTop: 40,
      padding: 15,
    };

    return (
      <Paper style={viewStyle}>
        <ContentBox
          title={
            error
              ? <FormattedMessage id="registration.activationFailure" />
              : <FormattedMessage id="registration.activationSuccessful" />
          }
        >
          {
            error && (
              <div>
                <FormattedMessage id={error} />
              </div>
            )
          }
        </ContentBox>
      </Paper>
    );
  }
}

type Props = RouteType;

export default withRouter(ActivateUser);
